var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f4f6c54b6a81b76d956fed8f14873ad64525c4ab"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fe-connect@unmind"]={id:"f4f6c54b6a81b76d956fed8f14873ad64525c4ab"};
      